/* eslint-disable */
import requestRaw from '@/utils/requestRaw'
import { APICore, APIReportPHP } from '@/utils/servicesApi'
// const qs = require('qs')

export function updateUserStats(instagramId) {
    return requestRaw({
        url: APICore() + '/brand/instagram_official/update_user_stats?instagram_id=' + instagramId,
        method: 'GET',
    })
}

export function connectAccountsFullAccess(data) {
    return requestRaw({
        url: APICore() + '/brand/instagram_official/connect_accounts_full_access',
        method: 'POST',
        data: data // untuk array data post
    })
}

export function refreshToken(data) {
    return requestRaw({
        url: APICore() + '/brand/instagram_official/refresh_token',
        method: 'POST',
        data: data // untuk array data post
    })
}

export function getInstagramBusinessAccount(data) {
    return requestRaw({
        url: APICore() + '/brand/instagram_official/get_instagram_business_account',
        method: 'POST',
        data: data // untuk array data post
    })
}

export function getProfile(id) {
    return requestRaw({
        url: APIReportPHP() + '/instagram/account/profile?instagram_id=' + id,
        method: 'GET'
    })
}

export function getInsightProfile(data) {
    return requestRaw({
        url: APIReportPHP() + `/instagram/account/insight_profile?instagram_id=${data.instagram_id}&percent_view=${data.percent_view}`,
        method: 'GET'
    })
}

export function getInsightProfilePercent(data) {
    return requestRaw({
        url: APIReportPHP() + `/instagram/account/insight_profile_percent?instagram_id=${data.instagram_id}&percent_view=${data.percent_view}`,
        method: 'GET'
    })
}

export function getInsightPost(data) {
    return requestRaw({
        url: APIReportPHP() + `/instagram/account/insight_post?instagram_id=${data.instagram_id}&percent_view=${data.percent_view}`,
        method: 'GET'
    })
}
export function getInsightPostPercent(data) {
    return requestRaw({
        url: APIReportPHP() + `/instagram/account/insight_post_percent?instagram_id=${data.instagram_id}&percent_view=${data.percent_view}`,
        method: 'GET'
    })
}

export function getMedia(data) {
    return requestRaw({
        url: APIReportPHP() + '/instagram/account/media_post',
        method: 'POST',
        data: data
    })   
}


// WEBPACK FOOTER //
// ./src/api/instagramAccountOfficial.js